<template>
  <!-- 户表列表 -->
  <div class="box">
    <!-- 查询条件区域 -->
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="户表列表"></SectionTitle>
      <el-form
        :inline="true"
        class="flex-grow-1 d-flex"
        :class="{ dark: skinType }"
        size="small"
      >
        <project-level-selector
          @selectItem="selectItemListener"
          levelType="xm"
          style="margin-right: 1rem"
        >
        </project-level-selector>
        <el-form-item label="关键字:" :class="{ 'light-label': skinType }">
          <el-input placeholder="全部" v-model="keyWords"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="font-size: 0.8rem" @click="chaxun"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div
      class="d-flex flex-column align-items-stretch"
      style="width: 100%; height: 100%; background-color: white"
    >
      <div style="overflow-y: auto; height: 100%; width: 100%">
        <el-table
          :data="tableDataS"
          class="table"
          @selection-change="handleSelectionChange"
          stripe
                    height="100%"
          size="small"
          :class="{ dark: skinType }"
          :row-class-name="
            (...nu) => {
              return skinType ? 'dark text-white' : '';
            }
          "
        >
          <el-table-column fixed type="index" width="60" label="#">
          </el-table-column>
          <el-table-column
            prop="EquipmentName"
            label="户表名称"
            width="150"
          ></el-table-column>
          <el-table-column prop="ZiChanBianHao" label="资产编号" width="160">
          </el-table-column>
          <el-table-column prop="FirmName" label="所属商户" width="110">
          </el-table-column>
          <el-table-column prop="ProjectName" label="所属项目" width="160">
          </el-table-column>
          <el-table-column prop="DangQianMaZhi" label="当前码值" width="120">
          </el-table-column>
          <el-table-column prop="Balance" label="商户余额" width="120">
          </el-table-column>
          <el-table-column
            prop="ZuoRiYongDianLiang"
            label="昨日用电量"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="ManMaZhi" label="满码值" width="150">
          </el-table-column>
          <el-table-column fixed="right" label="功能" width="210">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                disabled
                @click="handlePreview(scope.$index, scope.row)"
                icon="el-icon-set-up"
                title="控分"
                circle
              ></el-button>
              <el-button
                size="mini"
                type="primary"
                disabled
                @click="handlePreview(scope.$index, scope.row)"
                icon="el-icon-s-operation"
                title="控合"
                circle
              ></el-button>
              <el-button
                size="mini"
                type="primary"
                @click="handElectricity(scope.row)"
                icon="el-icon-tickets"
                title="用电记录"
                circle
              ></el-button>
              <el-button
                size="mini"
                type="primary"
                @click="handAnalysis(scope.row)"
                icon="el-icon-pie-chart"
                title="对比分析"
                circle
              ></el-button>
              <el-button
                size="mini"
                type="primary"
                @click="handValley(scope.row)"
                icon="el-icon-data-line"
                title="峰谷分析"
                circle
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        style="
          display: flex;
          padding: 1rem 1rem 1rem 0;
          justify-content: flex-end;
        "
        class="section-container"
        :class="{ dark: skinType }"
      >
        <el-pagination
          background
          layout="total, prev, pager, next"
          :class="{ 'text-white': skinType }"
          :current-page.sync="pageIndex"
          :total="pagetotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getMeterList } from '@/api/tenant/tenant';
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import SectionTitle from '@/components/utils/section-title.vue';

export default {
  components: {
    ProjectLevelSelector,
    SectionTitle,
  },
  data() {
    return {
      selectProject: null,
      tableDataS: [],
      keyWords: '',
      shujucount: [],
      multipleSelection: [],
      pageIndex: 1,
      pagetotal: 0,
      pageSize: 10,
      tableData: [],
    };
  },
  created() {
    this.requestRechargeList();
  },
  watch: {
    pageIndex() {
      this.requestRechargeList();
    },
    selectProject() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
      } else {
        this.requestRechargeList();
      }
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    selectItemListener(node) {
      if (node.oType === 'xm') {
        this.selectProject = node;
      }
    },
    requestRechargeList() {
      if (this.selectProject === null) {
        return;
      }
      // 初始化第一页
      getMeterList({
        ProjectIDstr: this.selectProject.IdStr,
        Page: this.pageIndex,
        Rows: this.pageSize,
        KeyWord: this.keyWords,
      })
        .then((res) => {
          this.tableDataS = res.list;
          this.pagetotal = res.total;
        })
        .catch(() => {
          this.tableDataS = [];
        });
    },
    // 点击查询
    chaxun() {
      this.pageIndex = 1;
      this.requestRechargeList();
    },
    // 点击跳转
    handElectricity(row) {
      this.$router.push({
        name: 'energy-list',
        params: { id: row.SBIDstr },
      });
    },
    handAnalysis(row) {
      this.$router.push({
        name: 'contrast',
        params: { id: row.SBIDstr },
      });
    },
    handValley(row) {
      this.$router.push({
        name: 'peakvalley',
        params: { id: row.SBIDstr },
      });
    },

    tableRowClassName({ row, rowIndex }) {
      // eslint-disable-next-line no-param-reassign
      row.row_index = rowIndex;
    },
    daochu() {},
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>
<style lang="less" scoped>
.selectmonth {
  width: 30%;
}
/* 全局文字居中 */
.el-table th > .cell {
  text-align: center;
}
.el-table .cell {
  text-align: center;
}
/deep/.el-form-item__label {
  font-size: 0.8rem !important;
}
/deep/.el-input__inner {
  font-size: 0.8rem !important;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

#sss {
  width: 10.7142rem !important;
}
#sss2 {
  width: 10.6rem !important;
}
.box {
  width: 100%;
  height: 100%;
}
/* 下拉 */

/* 日期选择 */

/* 数据表头 */

.Block > img {
  width: 14.2857rem;
  height: 4.2857rem;
  display: flex;
  position: fixed;
}
.shuzi {
  display: flex;
  font-size: 1.71428rem;
}
.shuzi > span {
  font-size: 1.21428rem;
  margin-top: 12%;
  margin-left: 10%;
}
.bigshu {
  z-index: 1;
  display: flex;
  flex-direction: column;
  margin-left: 35%;
}
.Block {
  display: flex;

  width: 14.2857rem;
  height: 4.2857rem;

  color: #ffffff;
  border-radius: 5px;
  align-items: center;
  justify-content: flex-start;
}
.form-query {
  padding: 0 2rem;
}
.enterwidth1 {
  position: relative;
}
.run-demonstration {
  width: 5rem;
}

/* .el-form--inline .el-form-item {
  display: inline-block;
  vertical-align: top;
} */
/* .deduct {
  background-color: #dd0a20;
  border: 1px solid #dd0a20;
}
.deduct:hover {
  background-color: #dd0a20;
  border-color: #dd0a20;
}
.deduct:active {
  background-color: #dd0a20;
  border-color: #dd0a20;
}
.deduct:visited {
  background-color: #dd0a20;
  border-color: #dd0a20;
} */
/* .form-query.el-form--inline .el-form-item:not(.button-container) {
  display: flex;
  width: 0;
  flex-grow: 1;
}
.query-item .el-form-item__content {
  width: 0;
  flex-grow: 1;
  display: flex;
}
.form-query.el-form--inline
  .el-form-item:not(.button-container)
  .el-form-item__content
  .el-date-editor.el-input {
  width: 0;
  flex-grow: 1;
} */
</style>
